export function slugifyCrewTemplateCode(value: string): string {
  const code = value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64)

  return code || 'crew_template'
}

export function ensureUniqueCrewTemplateCode(
  nameOrCode: string,
  existingCodes: string[],
  excludeCode?: string | null,
): string {
  const base = slugifyCrewTemplateCode(nameOrCode)
  const taken = new Set(
    existingCodes
      .map((entry) => entry.trim())
      .filter(Boolean)
      .filter((entry) => !excludeCode || entry !== excludeCode),
  )

  let candidate = base
  let counter = 2
  while (taken.has(candidate)) {
    const suffix = `_${counter}`
    candidate = `${base.slice(0, Math.max(1, 64 - suffix.length))}${suffix}`
    counter += 1
  }

  return candidate
}
